import { ContractorDocumentCategory } from './contractor-document-category';

export class ContractorDocument {
  id: string;
  documentName: string;
  contractorId: string;
  categoryId?: string = null;
  category?: ContractorDocumentCategory;
  documentPath: string;
  createdOn: string;
  createdBy: string;
  modifiedOn: string;
  modifiedBy: string;
  editing: boolean;

  constructor(options?: Partial<ContractorDocument>) {
    if (options) {
      Object.assign(this, options);
    }
  }
}
